import React from 'react';
import {
  Modal,
  Button,
  ButtonType
} from 'syngenta-digital-cropwise-react-ui-kit';
import WarningIcon from 'assets/warning_outlined.svg?react';
import {
  UNSAVED_CHANGES_STRINGS,
  WARNING_ICON_COLOR,
  MODAL_WIDTH
} from './constants';
import './index.css';

interface UnsavedChangesModalProps {
  open: boolean;
  onContinueEditing: () => void;
  onDiscard: () => void;
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  open,
  onContinueEditing,
  onDiscard
}) => (
  <Modal
    open={open}
    centered
    closable={false}
    maskClosable={false}
    width={MODAL_WIDTH}
    className="unsaved-changes-modal"
    onCancel={onContinueEditing}
    transitionName=""
    maskTransitionName=""
    // The title has to sit in the header slot: the dialog takes its accessible
    // name from there, and supplies none at all when the slot is empty. The
    // design's alignment is kept by indenting the body to the title's edge
    // instead, which is how the design draws it too.
    title={
      <span className="flex items-center gap-4">
        <span
          className="flex shrink-0 items-center"
          style={{ color: WARNING_ICON_COLOR }}
        >
          <WarningIcon width="24" height="24" />
        </span>
        <span className="unsaved-changes-title text-base font-semibold leading-6 text-neutral-1000">
          {UNSAVED_CHANGES_STRINGS.title}
        </span>
      </span>
    }
    footer={
      <div className="flex justify-end gap-2">
        <Button
          type={ButtonType.outline}
          size="large"
          onClick={onContinueEditing}
        >
          {UNSAVED_CHANGES_STRINGS.continueEditing}
        </Button>
        <Button type={ButtonType.primary} size="large" onClick={onDiscard}>
          {UNSAVED_CHANGES_STRINGS.discardChanges}
        </Button>
      </div>
    }
  >
    <p className="unsaved-changes-body pl-10 text-sm leading-5 text-neutral-1000">
      {UNSAVED_CHANGES_STRINGS.body}
    </p>
  </Modal>
);

export default UnsavedChangesModal;
